<template>
  <Modal class="mask" class-name="vertical-center-modal" v-model="show" :mask-closable="false">
    <div slot="header" class="modal-header">消息提醒</div>
    <div>
      该时间点前后半小时内已有带看，带看商机:<span>{{phoneStr}}</span>，是否继续选择该时间？
    </div>
    <div slot="footer">
      <Button type="text" size="large" @click="handleCancel">取消</Button>
      <Button type="primary" size="large" @click="confirm">
        <span>确定</span>
      </Button>
    </div>
  </Modal>
</template>
<script type="text/ecmascript-6">

export default {
  props:{
    n:{
      type:Number,
      default:0
    },
    phoneStr :{
      type:String,
      default:''
    }
  },
  data () {
  return {
    show:false
 };
 },
 watch:{
   n(val){
     this.show = true;
   }
 },
 methods:{
   handleCancel(){
      this.show = false
      this.$emit('cancelTimePick')
    },
   confirm(){
     this.show = false
   }
 }
}
</script>


